import React from 'react'
import { Flex, Layout } from 'antd'
import { Tag, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import { colorText } from 'src/app/themes/primaryThemeDefault'
import { WarningIcon } from 'src/assets/icons'
import { useSelector } from 'react-redux'
import { getCriticalConfig, getDefaultTimeZone } from 'src/app/store/masterSetup'
import RichTextField from 'src/app/shared/components/common/rich-text-field'
import './index.scss'

/* Localization TimeZone */
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import { useRolePermission } from 'src/app/shared/hooks/useRolePermission'
import { Navigate } from 'react-router-dom'
import { menuUrls } from 'src/app/shared/constants/menu.constants'
import { USER_ROLE } from 'src/app/shared/constants/app.constants'
import { useWindowSize } from 'src/app/shared/hooks/useWindowSize'
dayjs.extend(utc)
dayjs.extend(timezone)
/* Localization TimeZone */

const { Content } = Layout

const Home: React.FC = () => {
  const criticalConfig = useSelector(getCriticalConfig)
  const defaultTimeZone = useSelector(getDefaultTimeZone)

  const { role } = useRolePermission()
  const { mode } = useWindowSize()
  dayjs.tz.setDefault(defaultTimeZone?.code)
  const { homeBanner, homeLogo } = criticalConfig?.brandingImage || {}
  const {
    homeScreenMessage = '',
    bannerStartDate = '',
    bannerEndDate = '',
    specialBannerMessage = '',
  } = criticalConfig?.systemMessage || {}

  const currentDate = dayjs().tz(defaultTimeZone?.code)

  const isSpecialBannerMessageDisplay =
    (bannerStartDate ? currentDate.isAfter(dayjs.utc(bannerStartDate + 'T00:00:00+00:00')) : true) &&
    (bannerEndDate ? currentDate.isBefore(dayjs.utc(bannerEndDate + 'T23:59:59+00:00')) : true)

  const { t } = useTranslation()

  return (
    <Content>
      {role === USER_ROLE.IT_SYSTEM_ADMIN ? (
        <Navigate to={menuUrls.helpPageManagement} />
      ) : (
        <div className='home-content'>
          <Flex className={`home-text ${mode}`}>
            <Flex vertical>
              <Typography.Text
                style={{
                  fontWeight: '400',
                  fontSize: '48px',
                  fontFamily: 'Montserrat',
                  color: colorText,
                }}
              >
                {t('OverallFunctionality:home_welcome_text')}
              </Typography.Text>
              <span style={{ lineHeight: '40px', overflowWrap: 'break-word' }}>
                <span className='home-welcome-text gray-text-home'>
                  {t('OverallFunctionality:home_swb_text')}&nbsp;
                </span>
                <span className='home-welcome-text_sub' style={{ overflowWrap: 'break-word' }}>
                  <span style={{ fontWeight: '600', fontSize: '28px', color: colorText, overflowWrap: 'break-word' }}>
                    {t('OverallFunctionality:home_bfa_text')}&nbsp;
                  </span>
                  <span
                    className='gray-text-home'
                    style={{
                      overflowWrap: 'break-word',
                    }}
                  >
                    {t('OverallFunctionality:home_system_text')}
                  </span>
                </span>
              </span>
            </Flex>
            <img src={homeLogo} className={`home-logo ${mode}`} alt='home_logo' />
          </Flex>
          <div className={`home-text-message ${mode}`}>
            {homeScreenMessage && (
              <Tag
                style={{
                  padding: 8,
                  paddingRight: mode === 'mobile' ? 8 : 56,
                  alignItems: 'center',
                  display: 'flex',
                  gap: 16,
                  width: 'fit-content',
                }}
                icon={<WarningIcon style={{ fontSize: '18px' }} />}
                color='warning'
              >
                <Typography.Text
                  style={{
                    color: colorText,
                    display: 'block',
                    fontSize: '14px',
                    wordBreak: 'break-word',
                    overflowWrap: 'break-word',
                    whiteSpace: 'normal',
                  }}
                >
                  {homeScreenMessage}
                </Typography.Text>
              </Tag>
            )}

            {isSpecialBannerMessageDisplay && <RichTextField richText={specialBannerMessage || ''} />}
          </div>
          {mode !== 'mobile' && <img src={homeBanner} alt='home_logo' className={`home-banner ${mode}`} />}
        </div>
      )}
    </Content>
  )
}

export default Home
